exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-active[data-v-a985c61e]{border:3px solid #23d160}.button.is-info[data-v-a985c61e]{background-color:#98ca3f}.button.is-danger[data-v-a985c61e]{background-color:#b71132}nav .container a[data-v-a985c61e]:focus:not(:active),nav .container a[data-v-a985c61e]:not(:active),nav .container input[data-v-a985c61e],nav .container input[data-v-a985c61e]:active{outline:none;border-color:transparent;box-shadow:0!important}nav .container a[data-v-a985c61e],nav .container input[data-v-a985c61e]{border-radius:0}.message_count[data-v-a985c61e]{color:#fff;font-style:italic;font-size:14px;margin-top:5px}.list_albumes[data-v-a985c61e]{padding:0 1.5rem 3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a985c61e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Search.vue
// module id = 47
// module chunks = 0